/**
 * A function that does absolutely nothing.
 * And doing nothing is the assurance of not making a mistake.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = (..._args: any[]) => undefined;

export default noop;
